import type { FC } from "react";
import { ActivityGroupRow } from "web_myplann/Activities/Components/ActivityGroupRow";
import type { ActivityOrTaskListItem } from "web_myplann/Activities/Helpers/isActivityListItem";

type Props = {
	items: ActivityOrTaskListItem[];
};

export const ActivityGroupRows: FC<Props> = ({ items }) => (
	<>
		{items.map((item, index) => (
			<ActivityGroupRow
				key={item.id}
				item={item}
				showDivider={index < items.length - 1}
			/>
		))}
	</>
);
